export default __webpack_public_path__ + "static/m-team-1-137e28aa1733c74761f93087e12e124d.jpg";